import cn from 'classnames/bind'

import styles from './extended-label.module.scss';


const cx = cn.bind(styles)

type Props = {
  active: boolean,
  title: string,
}

const ExtendedLabel = ({ active, title }: Props) => (
  <span className={cx(styles.root, { active })}>{title}</span>
)

export default ExtendedLabel
